import React from 'react';
import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';

import SearchBox from '@/components/common/SearchBox';
import HeaderMenu from '@/HeaderMenu';
import DrawerTitle from '@/leftDrawer/DrawerTitle';

const HeaderClient = ({ credits }) => {
  return (
    <nav className="flex h-[70px] items-center bg-[#2B313C] text-white shadow-none">
      <div className="mx-auto flex w-[83.333333%] items-center">
        <div className="w-1/4 md:w-1/2">
          <DrawerTitle />
        </div>
        <div className="flex w-3/4 justify-end md:w-1/2">
          <HeaderMenu credits={credits} client />
        </div>
      </div>
    </nav>
  );
};

HeaderClient.propTypes = {
  credits: PropTypes.string,
};

const Header = ({ balance, client, features, headerSearchValue, handleHeaderSearch, userName, activeSubMenu }) => {
  const intl = useIntl();

  if (client) {
    let wallet = null;

    if (balance !== null && balance.includes(',')) {
      wallet = balance.slice(0, balance.indexOf(','));
    } else {
      wallet = balance;
    }

    return <HeaderClient credits={wallet} />;
  }

  return (
    <header className="relative z-[110] flex h-[54px] items-center bg-[#D1D1D1] pl-[220px] shadow-none">
      <div className="flex w-full items-center">
        <div className="flex w-1/2 items-center px-[1vw]">
          <SearchBox
            value={headerSearchValue}
            handler={handleHeaderSearch}
            options={activeSubMenu === 'active' ? { advanced: ['activeTabOrderStatus'] } : {}}
            isClientsPageHeader={false}
            placeholder={intl.formatMessage({ id: 'SEARCH' }) + '...'}
          />
        </div>
        
        <div className="flex w-1/2 items-center justify-end px-[1vw]">
          <HeaderMenu userName={userName} client={client} features={features} />
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  handleHeaderSearch: PropTypes.func,
  userName: PropTypes.string.isRequired,
  client: PropTypes.bool,
  balance: PropTypes.string,
  features: PropTypes.array,
  headerSearchValue: PropTypes.string,
  activeSubMenu: PropTypes.string,
};

Header.defaultProps = {
  handleHeaderSearch: () => {},
  client: false,
  balance: '',
  features: [],
  headerSearchValue: '',
  activeSubMenu: '',
};

export default Header;
